import { render } from "./FixedImage.vue?vue&type=template&id=3ebcf9b4&scoped=true"
import script from "./FixedImage.vue?vue&type=script&lang=js"
export * from "./FixedImage.vue?vue&type=script&lang=js"

import "./FixedImage.vue?vue&type=style&index=0&id=3ebcf9b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebcf9b4"]])

export default __exports__